<template>
    <div>
        <div v-if="incident">
            <b-container>
                <b-row>
                    <b-col sm="10">
                        <h2>
                            {{ incident.student.firstName }} {{ incident.student.lastName }} - {{ incident.studentCourse.subjectCode }}
                            {{ incident.studentCourse.catalogNumber }}
                        </h2>
                    </b-col>
                    <b-col sm="2">
                        <b-button class="btn-primary pull-right" @click="addFollowUp = true" v-if="!addFollowUp && isFaculty()">Follow Up</b-button>
                    </b-col>
                </b-row>
            </b-container>

            <b-container>
                <div class="widget">
                    <div class="widget-head">
                        <h3 class="heading">Details</h3>
                    </div>
                    <div class="widget-body">
                        <b-container>
                            <b-row class="detail-row">
                                <b-col sm="6">
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Submitted By
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.submitter.firstName }} {{ incident.submitter.lastName }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Email
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.submitter.email }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Department
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.department }}
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="6">
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Incident Date
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.incidentDate  | moment("MM/DD/YYYY") }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Recommendation Status
                                        </b-col>
                                        <b-col sm="9">
                                            <span v-if="incident.incidentRecommendation">{{ incident.incidentRecommendation.name }}</span>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row class="detail-row">
                                <b-col sm="6">
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Student
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.student.firstName }} {{ incident.student.lastName }} ({{ incident.student.asuriteId }})
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Email
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.student.asuemailAddress }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Major
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.major }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Year
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.year }}
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="6">
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Course
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.studentCourse.subjectCode }} {{ incident.studentCourse.catalogNumber }}
                                            ({{ incident.studentCourse.classNumber }})
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Title
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.studentCourse.courseTitle }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Instructor
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.studentCourse.instructor }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3" class="detail-label">
                                            Term
                                        </b-col>
                                        <b-col sm="9">
                                            {{ incident.studentCourse.termCode }}
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

                <div class="widget">
                    <div class="widget-head">
                        <h3 class="heading">Description</h3>
                    </div>
                    <div class="widget-body">
                        <p v-html="getDecodedHtml(incident.description)"></p>
                    </div>
                </div>

                <div class="widget" v-if="isAdmin()">
                    <div class="widget-head">
                        <h3 class="heading">Status</h3>
                    </div>
                    <div class="widget-body">
                        <span>{{ getCurrentStatusName(incident.incidentStatuses) }}</span>
                    </div>
                </div>

                <div class="widget" v-if="isAdmin()">
                    <div class="widget-head">
                        <h3 class="heading">Student Filing Grievance</h3>
                    </div>
                    <div class="widget-body">
                        <span>{{ incident.studentFilingGrievance ? 'Yes' : 'No' }}</span>
                    </div>
                </div>

                <div class="widget">
                    <div class="widget-head">
                        <h3 class="heading">Student Grievance</h3>
                    </div>
                    <div class="widget-body">
                        <p v-if="incident.studentGrievance" v-html="getDecodedHtml(incident.studentGrievance)"></p>
                        <span v-if="!incident.studentFilingGrievance">The student has not filed a grievance.</span>
                    </div>
                </div>

                <div class="widget">
                    <div class="widget-head">
                        <h3 class="heading">Disposition</h3>
                    </div>
                    <div class="widget-body">
                        <p v-if="incident.disposition" v-html="getDecodedHtml(incident.disposition)"></p>
                        <span v-if="!incident.disposition">No disposition has been entered.</span>
                    </div>
                </div>

                <div class="widget" v-if="!addFollowUp">
                    <div class="widget-head">
                        <h3 class="heading">Follow Up</h3>
                    </div>
                    <div class="widget-body">
                        <p v-if="incident.followUp" v-html="getDecodedHtml(incident.followUp)"></p>
                        <span v-if="!incident.followUp">No faculty follow-up has been entered.</span>
                    </div>
                </div>

                <form class="form-horizontal" @submit.prevent="submitFollowUp" v-if="addFollowUp">
                    <b-form-group label="Follow Up" label-class="control-label">
                        <vue-editor id="followUpEditor" v-model="incident.followUp"></vue-editor>
                    </b-form-group>
                    <b-button type="submit" class="pull-right" variant="primary">Save</b-button>
                </form>

            </b-container>
        </div>
    </div>
</template>

<script>
// text editor
import { VueEditor } from "vue2-editor";

import toastr from "toastr";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import { mapState } from "vuex";
import incidentsApi from "../../api/incidents";

var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {
      addFollowUp: false
    };
  },

  props: {
    incident: {
      required: true
    }
  },

  components: {
    VueEditor
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    getDecodedHtml(encodedString) {
      if (encodedString) {
        return htmlDecode(encodedString);
      } else {
        return "";
      }
    },

    isAdmin: function() {
      return _.find(this.user.userRoles, function(userRole) {
        return userRole === "Incidents.Admin";
      });
    },

    isFaculty: function() {
      return _.find(this.user.userRoles, function(userRole) {
        return userRole === "Incidents.Faculty";
      });
    },

    getCurrentStatusName(statuses) {
      if (statuses.length > 0) {
        return statuses[0].incidentStatusDefinition.name;
      }
      return null;
    },

    submitFollowUp() {
      var that = this;

      incidentsApi
        .submitFollowUp(this.incident)
        .then(function(response) {
          console.log(response);
          toastr.options = {
            closeButton: true,
            debug: false,
            newestOnTop: false,
            progressBar: false,
            positionClass: "toast-top-right",
            preventDuplicates: false,
            onclick: null,
            showDuration: "300",
            hideDuration: "0",
            timeOut: "5000",
            extendedTimeOut: "1000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
          };

          // Toastr Message
          toastr.success("Your follow up has been saved.", "Success");

          that.addFollowUp = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 100%;
}

.detail-label {
  text-align: right;
  font-weight: bold;
}

.widget-body {
  font-size: 14px;
}

.detail-row {
  margin: 20px 0 20px 0;
}

.control-label {
  padding-bottom: 0;
}
</style>
